import { DRIVER_TIMEOUT } from "../constants";

export const waitSomeTime = async (specificTime?: number) =>
  await new Promise((resolve) =>
    setTimeout(resolve, specificTime ?? DRIVER_TIMEOUT),
  );
